"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lngForesight = void 0;
const lngForesight = exports.lngForesight = {
  LNG_FORESIGHT: {
    en: {
      title: 'ICIS LNG Foresight',
      subtitle: 'Trade confidently in this increasingly complex, globalised market',
      description: 'Understand global LNG with pricing, supply and demand forecasts that include Asian demand fundamentals.',
      list: ['Live tracking of 700 LNG cargo vessels', 'Morning email alerts with cargo diversion and location into European terminals, tenders and outages', 'Demand forecasts up to two years ahead, month-by-month', 'LNG arbitrage calculator and tenders database']
    },
    zh: {
      title: 'ICIS LNG预测与分析',
      subtitle: '在这个日益复杂的全球化市场中自信地进行交易',
      description: '获取包括亚洲需求基本面在内的价格与供需预测，了解全球LNG市场动态。',
      list: ['实时追踪700艘LNG船舶动态', '发送晨间邮件通知，汇总欧洲货物转港、抵港码头、招标与装置停车消息', '未来两年的月度需求预测 ', 'LNG套利计算器与招标数据库']
    }
  }
};